import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=03bdff3d&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=03bdff3d&scoped=true&lang=css&"
import style1 from "./Contact.vue?vue&type=style&index=1&id=03bdff3d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdff3d",
  null
  
)

component.options.__file = "Contact.vue"
export default component.exports